
/*
 * Tees-4 Variant Gallery Fix
 *
 * Displays the correct garment image when a product page
 * is opened with a ?variant= URL parameter.
 *
 * Uses Fearless's existing thumbnail controls.
 * Does not modify the variant picker or TeeInBlue.
 */

(function () {
  "use strict";

  async function activateSelectedVariantImage() {
    
console.log(
  "[Tees-4 Gallery] Automatic script started",
  new Date().toLocaleTimeString()
);

    // Only run on product pages with a selected variant.
    const variantId = new URLSearchParams(
      window.location.search
    ).get("variant");

    if (!variantId) return;

    const gallery = document.querySelector(
      "[data-product-root] [data-media-gallery]"
    );

    if (!gallery) return;

    try {
      const response = await fetch(
        window.location.pathname + ".js",
        { credentials: "same-origin" }
      );

      if (!response.ok) return;

      const product = await response.json();

      const variant = product.variants.find(
        item => String(item.id) === variantId
      );

      if (!variant || !variant.featured_image) return;

      const imageUrl = variant.featured_image.src;

      if (!imageUrl) return;

      const imageFilename = decodeURIComponent(
        new URL(imageUrl, window.location.origin)
          .pathname.split("/").pop()
      );

      const imageItem = Array.from(
        gallery.querySelectorAll("[data-media-item]")
      ).find(item => {
        return Array.from(
          item.querySelectorAll("img")
        ).some(img => {
          const src = img.currentSrc || img.src;

          if (!src) return false;

          try {
            const filename = decodeURIComponent(
              new URL(src, window.location.origin)
                .pathname.split("/").pop()
            );

            return filename === imageFilename;
          } catch (error) {
            return false;
          }
        });
      });

      
if (!imageItem) {
  console.log(
    "[Tees-4 Gallery] Matching image NOT found:",
    imageFilename
  );
  return;
}

console.log(
  "[Tees-4 Gallery] Matching image found:",
  imageFilename,
  "Media ID:",
  imageItem.dataset.mediaId
);


      const thumbnail = Array.from(
        gallery.querySelectorAll(
          "button[data-media-id]"
        )
      ).find(button => {
        return button.dataset.mediaId ===
          imageItem.dataset.mediaId;
      });

      if (!thumbnail) return;

      // Let Fearless handle the actual gallery transition.
      thumbnail.click();

      console.log(
        "[Tees-4] Selected variant image activated:",
        imageFilename
      );

    } catch (error) {
      console.warn(
        "[Tees-4] Variant gallery initialization:",
        error
      );
    }
  }

  
function initialize() {
  // Wait for Fearless to initialize its product gallery.
  window.setTimeout(
    activateSelectedVariantImage,
    2000
  );
}


  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
